import * as React from 'react'
import { FC, useEffect } from 'react'
import DivisionModal from '@modals/DivisionModal'
import { useGetDivisionQuery } from '@services/divisions'
import Loader from '@organisms/Loader'
import AccordionBodyFieldWithTabs from '@templates/AccordionBodyFieldWithTabs'
import AccordionBodyFieldsEmployees from '@templates/AccordionBodyFieldsEmployees'
import EmployeesCountField from '@templates/EmployeesCountField'

type Props = {
  id: number
  onSuccess?: () => void
}

const DivisionListItem: FC<Props> = ({ id, onSuccess }) => {
  const { data, isLoading, isSuccess } = useGetDivisionQuery(id)
  const {
    title = '',
    countEmployees = 0,
    curators,
    company,
    companyBranch,
  } = data || {}

  useEffect(() => {
    if (isSuccess) {
      onSuccess?.()
    }
  }, [isSuccess])

  return (
    <Loader isLoading={isLoading}>
      <AccordionBodyFieldWithTabs
        label="Наименование"
        items={[
          {
            id: '1',
            title,
            editModal: {
              Component: DivisionModal,
              props: {
                division: data,
              },
            },
          },
        ]}
      />
      <EmployeesCountField
        countEmployees={countEmployees}
        company={
          company
            ? {
                label: company.title,
                value: company['@id'],
              }
            : undefined
        }
        filial={
          companyBranch
            ? {
                label: companyBranch.title,
                value: companyBranch['@id'],
              }
            : undefined
        }
        division={
          data
            ? {
                label: data.title,
                value: data['@id'],
              }
            : undefined
        }
        isAccordionField
      />
      <AccordionBodyFieldsEmployees
        label="Кураторы подразделения"
        users={curators}
      />
    </Loader>
  )
}

export default DivisionListItem
